<section class="faq">
  <div
    class="container d-flex flex-column flex-lg-row justify-content-between align-items-center py-5"
  >
    <div class="row d-flex justify-content-between align-items-center">
      <div class="col-md-12 col-lg-6">
        <h1>{{ "faq.title" | translate }}</h1>
        <p class="mt-3 fs-5">
          {{ "faq.paragh" | translate }}
        </p>
        <div class="mt-4 d-flex flex-wrap gap-3">
          <button class="custom-faq-btn" routerLink="/contact">
            <span class="btn-text-content">
              {{ "faq.btn-send-msg" | translate }}
              <img
                src="/public/icons/arrow-right.svg"
                alt="Arrow"
                class="main-arrow"
              />
            </span>

            <div class="hover-circle">
              <img
                src="/public/icons/arrow-right.svg"
                alt="Arrow"
                class="hover-arrow"
              />
            </div>
          </button>
        </div>
      </div>

      <div class="col-md-12 col-lg-6 text-center pe-0">
        <img
          src="/public/data/Green and Yellow Creative Charity Video (1) 1.svg"
          alt="HilberTech Logo"
          class="img-fluid"
        />
      </div>
    </div>
  </div>
</section>

<section class="faq-accordion">
  <div class="container py-5">
    <div class="accordion" id="accordionExample">
      <!-- Question 1 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            1. Who We Are ?
          </button>
        </h2>
        <div
          id="collapseOne"
          class="accordion-collapse collapse show"
          aria-labelledby="headingOne"
          data-bs-parent="#accordionExample"
        >
          <div class="accordion-body">
            Hilbertech is a forward-thinking software house specializing in
            building scalable digital solutions for startups and enterprises. We
            combine strategy, design, and development to deliver
            high-performance web and mobile applications. We aim to transform
            ideas into reliable, user-centered products powered by modern
            technology.
          </div>
        </div>
      </div>

      <!-- Question 2 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingthree">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsethree"
            aria-expanded="false"
            aria-controls="collapsethree"
          >
            2. How do you kick off a new project before development starts?
          </button>
        </h2>
        <div
          id="collapsethree"
          class="accordion-collapse collapse"
          aria-labelledby="headingthree"
          data-bs-parent="#accordionExample"
        >
          <div class="accordion-body">
            We start by exploring your business objectives and the core
            challenges you want to address. Our team analyzes your target users,
            current workflows, technical environment, and any limitations such
            as budget, timeline, or regulatory requirements. Based on these
            insights, we outline the project scope, define the technical
            strategy, and create a clear roadmap — ensuring full alignment
            before moving into development.
          </div>
        </div>
      </div>
      <!-- Question 3 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingfour">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsefour"
            aria-expanded="false"
            aria-controls="collapsefour"
          >
            3. How long does it take to develop a custom software solution?
          </button>
        </h2>
        <div
          id="collapsefour"
          class="accordion-collapse collapse"
          aria-labelledby="headingfour"
          data-bs-parent="#accordionExample"
        >
          <div class="accordion-body">
            The development timeline varies depending on the scope, features,
            and technical complexity of the project. MVPs and smaller solutions
            can typically be delivered within a few months, while
            enterprise-level systems are developed in structured phases. We
            prioritize early feature releases, allowing you to track progress,
            collect user feedback, and continuously refine the product
            throughout the development cycle.
          </div>
        </div>
      </div>
      <!-- Question 4 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingfive">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsefive"
            aria-expanded="false"
            aria-controls="collapsefive"
          >
            4. How do you ensure software reliability and security?
          </button>
        </h2>
        <div
          id="collapsefive"
          class="accordion-collapse collapse"
          aria-labelledby="headingfive"
          data-bs-parent="#accordionExample"
        >
          <div class="accordion-body">
            We adopt a well-defined development workflow supported by continuous
            testing and code reviews at every stage. Potential risks and bugs
            are addressed early to maintain stability and performance. Security
            is embedded into the development lifecycle, particularly when
            managing sensitive data and core systems. Prior to deployment, the
            product undergoes thorough real-world testing to validate
            functionality, security, and overall reliability.
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
